import request from "@/utils/request.js";
const baseURL = '/publicity'

const api = {
    homeGsList: (data) => {
        return request({
            url: baseURL + "/api/wxzjgsxx/gzh/homePageList",
            method: "post",
            data,
        });
    },
}
export default api;